import { memo, useCallback, forwardRef, useState, useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { BzChip, BzInputText } from "../../components";
import { useDebounce, useSingleKey } from "../../hooks";
import { getSearchAllScrips, getSearchScripsOptions, resetSearchData, searchFailure } from "../../redux/actions/globalSearch";
import { EXCHANGE_NAME_NOTIFICATION, GLOBAL_SEARCH_MIN_LENGTH, INLINE_SEARCH_MAX_SEARCH_SCRIP_PER_PAGE, LOCAL_STORAGE_KEYS, SCRIP_INSTRUMENTS, WATCHLIST_GRID_INDEX } from "../../utils/global_variables";
import { getApiExchangeNameFromMktSegId, getDecryptLocalStorage, getExchangeName } from "../../utils/global_functions";

let strInputSearch = '';
let arrCurrentFocusedScrip = [];

const InlineScripSeach = forwardRef(({ className = '', handleSelectScripFromGlobalSearch, setBToggleSearchBar, bOpt, bFut, pageFrom, bSelectedCalculatorScrip = true, bIsFutureFair = false, legDataFromMultilegPage }, ref) => { //BT-113338 Implementing header changes ManasaB  Added forwaredRef and ref: 15/07/2023
    const dispatch = useDispatch();
    const { data: arrAllScrips = [] } = useSelector(state => state?.globalSearch?.searchAllScrips);
    const { data: arrOptScrips = [] } = useSelector(state => state?.globalSearch?.searchOptScrips);
    const multiLegData = useSelector(state => state.orders?.multiLegData);
    const [PAGE_FROM, setPageFrom] = useState(INLINE_SEARCH_MAX_SEARCH_SCRIP_PER_PAGE); //ManasaB : 15/11/2023 : BT-115821 : Alerts SAT Issue Resolve
    //Vaibhav Singh: BT-109089: 15-11-23: Called UserId : Start
    const { userId } = useSelector(state => state.auth);
    //Vaibhav Singh: BT-109089: 15-11-23: Called UserId : End
    // ---BT-107433_SrikanthRao_09-11-2023_Calculator || For Saperating Option,Future and All Scrips -start
    let arrScrips = [];
    if (bOpt && pageFrom !== "multileg") { // Ajitesh 02/07/2024 Remove multileg part of condition later when tab of futures and options is shown
        arrScrips = arrOptScrips;
    }
    // Ajitesh 03/07/2024 Condition specific for multileg page as we will need all FUT and OPT data so need to get data from arrAllScrips in redux
    else if (bOpt && pageFrom === "multileg") {
        arrScrips = arrAllScrips;
    }
    else if (bFut) {
        //ManasaB : 23/03/2024 : BT-107433 Calculator SAT2 Bug Fixing - Start
        if (bIsFutureFair) {
            arrScrips = arrAllScrips.filter(eachScrip => eachScrip[WATCHLIST_GRID_INDEX.NSPREAD] === 0);

        }
        else {
            arrScrips = arrAllScrips;
        }

        //ManasaB : 23/03/2024 : BT-107433 Calculator SAT2 Bug Fixing - Start
    } else {
        arrScrips = arrAllScrips;
    }
    // const arrScrips = bOpt ? (arrOptScrips.concat(arrFutScrips)) : arrAllScrips;
    // ---BT-107433_SrikanthRao_09-11-2023_Calculator || For Saperating Option,Future and All Scrips -start


    //Maaz A : 15-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - NSECDS Bug Fixes - Start
    const [strInputText, setStrInputText] = useState('');
    //Maaz A : 15-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - NSECDS Bug Fixes - End

    //Maaz A : 15-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - NSECDS Bug Fixes - Start
    const onChangeGlobalSearch = useCallback((e) => {
        const strGlobalSearchText = e.target.value;
        // Ajitesh 03/07/2024 Get exchange name from base scrip eg BSE_CUR, MCX_FO etc
        const exchangeNameFromLegData = pageFrom === "multileg" ? getExchangeName(legDataFromMultilegPage?.[WATCHLIST_GRID_INDEX.SEGMENT_ID]) : "";
        //Vaibhav Singh: BT-109089: 15-11-23: Added Exchange allowed segments : Start
        const mktAllowed = JSON.parse(getDecryptLocalStorage(`${LOCAL_STORAGE_KEYS.USER_DETAILS}_${userId}`));
        dispatch(resetSearchData());
        if (strGlobalSearchText && strGlobalSearchText?.length >= GLOBAL_SEARCH_MIN_LENGTH) {
            // eslint-disable-next-line react-hooks/rules-of-hooks
            useDebounce(() => {
                setStrInputText(e.target.value);
                strInputSearch = strGlobalSearchText;
                if (pageFrom === "multileg") {
                    let isCurrency = legDataFromMultilegPage[WATCHLIST_GRID_INDEX.EXCHANGE_SEGMENT]?.includes(SCRIP_INSTRUMENTS?.CUR_TEXT) || legDataFromMultilegPage[WATCHLIST_GRID_INDEX.INSTRUMENT]?.includes(SCRIP_INSTRUMENTS?.CUR_TEXT);
                    // Ajitesh 03/07/2024 prepare accurate search term for use in API eg GOLD MXC CURNCY
                    const searchTerm = `${e.target.value.toUpperCase()} ${exchangeNameFromLegData} ${isCurrency ? "CURNCY" : "COMMDTY"}`;
                    dispatch(getSearchAllScrips(searchTerm, mktAllowed?.nExchangesViewAllowed ? mktAllowed?.nExchangesViewAllowed : -1, 0, INLINE_SEARCH_MAX_SEARCH_SCRIP_PER_PAGE));
                }
                else if (bOpt) {
                    dispatch(getSearchScripsOptions(e?.target?.value?.toUpperCase(), mktAllowed?.nExchangesViewAllowed ? mktAllowed?.nExchangesViewAllowed : -1, 0, INLINE_SEARCH_MAX_SEARCH_SCRIP_PER_PAGE, true, true
                    ));//ManasaB : 30/11/2023 : BT-115296 Calculator Bug Fixing
                } else if (bFut) {
                    dispatch(getSearchAllScrips(e?.target?.value?.toUpperCase(), mktAllowed?.nExchangesViewAllowed ? mktAllowed?.nExchangesViewAllowed : -1, 0, INLINE_SEARCH_MAX_SEARCH_SCRIP_PER_PAGE));
                    // dispatch(getSearchScripsFutures(e?.target?.value?.toUpperCase(), mktAllowed?.nExchangesViewAllowed ? mktAllowed?.nExchangesViewAllowed : -1, 0, INLINE_SEARCH_MAX_SEARCH_SCRIP_PER_PAGE, true, true
                    // ));//ManasaB : 23/03/2024 : BT-107433 Calculator SAT2 Bug Fixing

                } else {

                    dispatch(getSearchAllScrips(e?.target?.value?.toUpperCase(), mktAllowed?.nExchangesViewAllowed ? mktAllowed?.nExchangesViewAllowed : -1, 0, INLINE_SEARCH_MAX_SEARCH_SCRIP_PER_PAGE));
                }
            }, 1000);
            //Vaibhav Singh: BT-109089: 15-11-23: Added Exchange allowed segments : End
        } else {
            setStrInputText('');
            dispatch(resetSearchData());
        }
    }, [bOpt, dispatch, bFut, userId, multiLegData]);
    //Maaz A : 15-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - NSECDS Bug Fixes - End
    //BT-107433 : Calculator : SAT Issues : ManasaB : 07-03-2024 : Scrolling issue - Start
    const handleSearchScripsScroll = useCallback((e, tab) => {
        // Ajitesh 03/07/2024 Get exchange name from base scrip eg BSE_CUR, MCX_FO etc
        const exchangeNameFromLegData = pageFrom === "multileg" ? getApiExchangeNameFromMktSegId(legDataFromMultilegPage[WATCHLIST_GRID_INDEX.SEGMENT_ID]) : "";
        //Vaibhav SIngh:BT-109089: 01-12-23: Added mktAllowed in Inline Search: Start
        if (e.target.scrollHeight <= Math.round(e.target.scrollTop + e.target.offsetHeight + 5)) {
            const mktAllowed = JSON.parse(getDecryptLocalStorage(`${LOCAL_STORAGE_KEYS.USER_DETAILS}_${userId}`));
            if (strInputSearch?.length >= GLOBAL_SEARCH_MIN_LENGTH) { //BT-114263 : Removing "All" tab and Adding count in search tabs : ManasaB : 24/07/2023
                if (pageFrom === "multileg") {
                    // Ajitesh 03/07/2024 prepare accurate search term for use in API eg GOLD MXC FUT
                    const searchTerm = strInputSearch.toUpperCase() + " " + EXCHANGE_NAME_NOTIFICATION[exchangeNameFromLegData] + " ";;
                    dispatch(getSearchAllScrips(searchTerm.toUpperCase(), mktAllowed?.nExchangesViewAllowed ? mktAllowed?.nExchangesViewAllowed : -1, PAGE_FROM, INLINE_SEARCH_MAX_SEARCH_SCRIP_PER_PAGE));
                }
                else {
                    //ManasaB : 15/11/2023 : BT-115821 : Alerts SAT Issue Resolve  - Start
                    dispatch(getSearchAllScrips(strInputSearch?.toUpperCase(), mktAllowed?.nExchangesViewAllowed ? mktAllowed?.nExchangesViewAllowed : -1, PAGE_FROM, INLINE_SEARCH_MAX_SEARCH_SCRIP_PER_PAGE));
                }
                if (bOpt && pageFrom !== "multileg") {
                    dispatch(getSearchScripsOptions(strInputSearch.toUpperCase(), mktAllowed?.nExchangesViewAllowed ? mktAllowed?.nExchangesViewAllowed : -1, PAGE_FROM, INLINE_SEARCH_MAX_SEARCH_SCRIP_PER_PAGE, true, true
                    ));
                }
                //BT-107433 : Calculator : SAT2 Issues : ManasaB : 23-03-2024 - Start
                if (bIsFutureFair && pageFrom !== "multileg") {
                    // dispatch(getSearchScripsFutures(strInputSearch.toUpperCase(), mktAllowed?.nExchangesViewAllowed ? mktAllowed?.nExchangesViewAllowed : -1, PAGE_FROM, INLINE_SEARCH_MAX_SEARCH_SCRIP_PER_PAGE, true, true
                    // ));
                    dispatch(getSearchAllScrips(strInputSearch?.toUpperCase(), mktAllowed?.nExchangesViewAllowed ? mktAllowed?.nExchangesViewAllowed : -1, PAGE_FROM, INLINE_SEARCH_MAX_SEARCH_SCRIP_PER_PAGE));
                }
                //BT-107433 : Calculator : SAT2 Issues : ManasaB : 23-03-2024 - End
                setPageFrom(prevState => prevState + INLINE_SEARCH_MAX_SEARCH_SCRIP_PER_PAGE);
                //ManasaB : 15/11/2023 : BT-115821 : Alerts SAT Issue Resolve  - Start
            } else { }
        } else { }
        //Vaibhav SIngh:BT-109089: 01-12-23: Added mktAllowed in Inline Search: End
    }, [PAGE_FROM, arrOptScrips, strInputSearch]);
    //BT-107433 : Calculator : SAT Issues : ManasaB : 07-03-2024: Scrolling issue - End
    //BT-113338 Implementing header changes ManasaB : 15/07/2023 - Start
    const handleInnerSearch = () => {
        // ---BT-107433_SrikanthRao_08-11-2023_Calculator || Functional Implementation For Search Icon
        if (bSelectedCalculatorScrip) {
            setBToggleSearchBar(false);
        } else {
            setBToggleSearchBar(true);
        }
    };
    //BT-113338 Implementing header changes ManasaB : 15/07/2023 - End

    //Maaz A : 04-10-2023 : BT-102298 - Breeze - Single Scrip Order entry - Start
    const onRowFocus = (each, e) => {
        arrCurrentFocusedScrip = each;
    };

    useSingleKey('enter', (e) => {
        handleSelectScripFromGlobalSearch(arrCurrentFocusedScrip);
    });

    useEffect(() => {
        return () => dispatch(searchFailure({ data: [], count: 0 }));
    }, [dispatch]);
    //Maaz A : 04-10-2023 : BT-102298 - Breeze - Single Scrip Order entry - End
    useEffect(() => {
        ref?.current?.focus();
    }, []);
    return (
        <>
            {/*BT-114569:Functional Implementation:Vaibhav Singh:31-07-2023: ClassNames changes for Inline search by Bhagyashree for scroll */}
            <div className={`inline-search-wrapper ${className}`}>
                <div className={`${pageFrom === "sidetray" ? '' : ""}`}>
                    <div className='position-relative w-100'>
                        <div className='icon-14 icon-search icon-grey search-icon-position' onClick={handleInnerSearch}></div>
                        <BzInputText type='search' size="sm" className='font-regular p-l-30 scripname-searchtext' placeholder='Search scrips' onChange={onChangeGlobalSearch} ref={ref} />
                    </div>
                </div>

                {/* on clicking search book this dropdown should be visible */}
                {arrScrips?.length > 0 ?
                    <Row onScroll={handleSearchScripsScroll} className='g-0 inline-search-wrap cursor-pointer'>
                        <Col>
                            <Container fluid className='g-0'>
                                {arrScrips?.length > 0 && arrScrips?.map((each, i) =>
                                    <Row tabIndex={0} className={'g-0 p-2 inline-search-scrip-list'} onFocus={onRowFocus.bind(this, each)} key={i} onClick={handleSelectScripFromGlobalSearch?.bind(this, each)}>
                                        <Col md={9}>
                                            <Container fluid className='g-0'>
                                                <Row className='g-0'>
                                                    <Col className='d-flex justify-content-start align-items-center'>
                                                        <div className='font-medium font-size2 color-text text-uppercase me-2'>{each[WATCHLIST_GRID_INDEX.DISPLAY_DESC]}</div>
                                                        <div className='chips-wrap'>
                                                            <BzChip className='exchange-chip'>{each[WATCHLIST_GRID_INDEX.EXCHANGE]}</BzChip>
                                                        </div>
                                                         {/*By HiralK : 05-08-2023 - To resolve Search Description issue*/}
                                                    </Col>
                                                </Row>
                                                {/* Bhagyashri P [07-12-2023] : BT-107433 Calculators Integration - class changes Starts */}
                                                <Row className='g-0 mt-1'>
                                                    <Col className='d-flex justify-content-start'>
                                                        <div className='font-regular font-size1 color-subtext text-capitalize'>{each[WATCHLIST_GRID_INDEX.SECURITY_DESCRIPTION]}</div>
                                                    </Col>
                                                </Row>
                                                {/* Bhagyashri P [07-12-2023] : BT-107433 Calculators Integration - class changes Ends */}
                                            </Container>
                                        </Col>
                                    </Row>
                                )}
                            </Container>
                        </Col>
                    </Row>
                    //Maaz A : 15-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - NSECDS Bug Fixes - Start
                    : (
                        arrScrips?.length === 0 && strInputText?.length > 0 &&
                        <Row onScroll={handleSearchScripsScroll} className='g-0 inline-search-wrap cursor-pointer'>
                            <Col>
                                <Container fluid className='g-0'>
                                    <div className='zero-state-alerts zero-state-alerts-xl'>
                                        <div className='icon-64 icon-nodata mrgauto mb-3'></div>
                                        <div className='font-medium font-size4 color-text mb-1'>No matches found</div>
                                        <div className='font-regular font-size2 color-nodata'>Try adjusting your search to find what you are looking for</div>
                                    </div>
                                </Container>
                            </Col>
                        </Row>
                    )
                    //Maaz A : 15-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - NSECDS Bug Fixes - End
                }
            </div>
        </>
    );
});
export default memo(InlineScripSeach);;